import { motion } from 'framer-motion';

export function ProgressBar({ current, total }) {
  const pct = Math.round(((current + 1) / total) * 100);
  return (
    <div data-testid="lesson-progress" className="sticky top-0 z-10 bg-[#F9F8F6] pt-4 pb-3">
      <div className="flex items-center justify-between text-[11px] uppercase tracking-widest text-navy/50 mb-2">
        <span data-testid="lesson-step-label">Step {current + 1} of {total}</span>
        <span>{pct}% complete</span>
      </div>
      <div className="h-1.5 bg-navy/10 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gold rounded-full"
          initial={false}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
        />
      </div>
    </div>
  );
}
